/**
 * Authentication service.
 *
 * Exposes the app-wide {@link IAuthService} instance — Supabase Auth is the
 * only implementation (mock mode was removed app-wide).
 *
 * @module features/auth/services/authService
 */

import type { IAuthService } from './authService.types';
import { SupabaseAuthService } from './supabaseAuthService';

/**
 * Auth service instance — Supabase-backed.
 */
export const authService: IAuthService = new SupabaseAuthService();

// Re-exports for testing and external consumers.
export type { IAuthService };
export { SupabaseAuthService };
